<template>

  <v-container>
   <v-row align="center" class="full-height" justify="center">
      <iframe  frameborder="0" 
    marginheight="0" 
    marginwidth="0" 
    width="100%" 
    :height="windowHeight" 
    src="https://member.kingpower.com">
  </iframe>
    </v-row>

    
  </v-container>

</template>
<script>
export default {
   data() {
        return {
           windowHeight:'',
        }
    },
    mounted() {
       this.windowHeight = window.innerHeight -100;
       console.log(this.windowHeight);
       this.$store.commit("setTitlePage","Kingpower Member");
    }
}
</script>

